import React from 'react'
import Row from './Row'
import '../css/List.css'

export default ({ tiers }) => (
  <div>
    <div>
      <div>
        <h3 className="distribution-header">Distribution Breakdown </h3>
        <div className="table-header">
          <div className="column tiers-column">Tiers</div>
          <div className="column rate-column">Rate</div>
          <div className="column blended-column">APY Ranges</div>
        </div>
      </div>

      <div className="even" style={{ marginTop: '0px' }}>
        <Row {...tiers[0]} />
      </div>
      <div className="odd">
        <Row {...tiers[1]} />
      </div>
      <div className="even">
        <Row {...tiers[2]} />
      </div>
      <div className="odd">
        <Row {...tiers[3]} />
      </div>
      <div className="even">
        <Row {...tiers[4]} />
      </div>
      <div className="odd">
        <Row {...tiers[5]} />
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/List.js